import {withWriteIntents} from './write-intents';
import { isset, intval, in_array, strval } from '../../php-compat';
import type { PortEnv, PhpRef } from '../../port-contract';
import { isArray, slot, array, values, type Arr } from './access';
export interface RefundDeps {
    find_caster_layer_provider_arrs(caster: Arr, layer: string): Arr;
    layer_has(row: Arr, layer: string): boolean;
    layer_value(row: Arr, layer: string): unknown;
    layer_entries(row: Arr, layer: string): Arr;
    ft_normalize_layer_entries_to_distinct_uuids(entries: Arr): Arr;
    ft_resolve_layer_entry(id: string, caster: Arr): unknown;
    item_field(row: Arr, field: string): unknown;
    ft_sanguine_claim_charge_receipt(caster: PhpRef<Arr>, affected: PhpRef<Arr>, status: string, sanguine: string): Arr;
    adjust_charges(caster: PhpRef<Arr>, affected: PhpRef<Arr>, id: string, delta: unknown, roll: string, log: boolean): unknown;
}
/** PHP: ft_sanguine_refund_consumed_carrier (includes/functions/janus/core/template_spell_roll.php:17) */
export function ftSanguineRefundConsumedCarrier(caster: PhpRef<Arr>, affected: PhpRef<Arr>, carrier: Arr,
    baseLevel: number, roll: string, refunded: PhpRef<Arr>, env: PortEnv<RefundDeps>) {
    return withWriteIntents(env, env => {
        const status = strval(slot(carrier, 'status_id') ?? ''), sanguine = strval(slot(carrier, 'status_item_id') ?? '');
        if (status === '' || sanguine === '' || isset(refunded.value, status)) return null;
        for (const provider of values(env.deps.find_caster_layer_provider_arrs(caster.value, 'sanguine_free_for_sanguine'))) {
            if (!env.deps.layer_has(provider as Arr, 'sanguine_free_max_spell_level')
                || baseLevel > Number(intval(env.deps.layer_value(provider as Arr, 'sanguine_free_max_spell_level')))
                || !in_array(sanguine, env.deps.ft_normalize_layer_entries_to_distinct_uuids(env.deps.layer_entries(provider as Arr, 'sanguine_free_for_sanguine')), true)) continue;
            const source = env.deps.ft_resolve_layer_entry(sanguine, caster.value);
            if (!isArray(source) || env.deps.item_field(source, 'item_type') !== 'sanguine') return null;
            const next = array(refunded.value); next.set(status, true); refunded.value = next;
            for (const [pool, qty] of array(env.deps.ft_sanguine_claim_charge_receipt(caster, affected, status, sanguine)))
                env.deps.adjust_charges(caster, affected, strval(pool), qty, roll, true);
            return null;
        }
        return null;
    });
}
